export default __webpack_public_path__ + "static/media/Bayer-Logo-colores.479392c6.svg";